import { HttpInterceptorFn, provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, EnvironmentProviders, Provider, inject, provideAppInitializer } from '@angular/core';
import { ZOP_MOCK_API_DEFAULT_DELAY } from '../mock-api/mock-api.constants';
import { mockApiInterceptor } from '../mock-api/mock-api.interceptor';

export type ZopCoreProviderConfig = {
  mockApi?: {
    delay?: number;
    services?: any[];
  };
  httpInterceptors?: HttpInterceptorFn[];
};

/**
 * Zop provider
 */
export const provideZopCore = (
  config: ZopCoreProviderConfig
): Array<Provider | EnvironmentProviders> => {
  // Base providers
  const providers: Array<Provider | EnvironmentProviders> = [
    {
      provide: ZOP_MOCK_API_DEFAULT_DELAY,
      useValue: config?.mockApi?.delay ?? 0,
    },
  ];

  // Collect all interceptors
  const interceptors: HttpInterceptorFn[] = [...(config?.httpInterceptors || [])];
  
  // Add mock API interceptor if mock API services are provided
  if (config?.mockApi?.services && config.mockApi.services.length > 0) {
    interceptors.push(mockApiInterceptor);
  }

  // Always provide HTTP client - with interceptors if any, otherwise basic HTTP client
  if (interceptors.length > 0) {
    providers.push(provideHttpClient(withInterceptors(interceptors)));
  } else {
    providers.push(provideHttpClient());
  }

  // Mock Api services
  if (config?.mockApi?.services) {
    config.mockApi.services.forEach((service) => {
        providers.push(provideAppInitializer(() => {
          const initializerFn = (() => (): any => inject(service))();
          return initializerFn();
        }));
    });
  }

  // Return the providers
  return providers;
};
